import LMUnderservedEvents from './view';

const LMUnderservedEventsPage = {
    name: 'LastMinuteUnderservedEvents',
    list: LMUnderservedEvents
};
export default LMUnderservedEventsPage;